export const handleKeyBoardNavigation = _ref => {
  let {
    event,
    tabButtonRef,
    onSelectTab
  } = _ref;
  var _a;
  if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
  const buttonsWrapper = (_a = tabButtonRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
  const tabsWrapper = buttonsWrapper.parentElement;
  const elementsToNavigate = buttonsWrapper.childNodes;
  const firstElement = elementsToNavigate[0];
  const lastElement = elementsToNavigate[elementsToNavigate.length - 1];
  elementsToNavigate.forEach((_, index) => {
    if (elementsToNavigate[index] !== event.target) {
      return;
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      const nextElement = elementsToNavigate[index + 1];
      const elementoToNavigate = !nextElement ? firstElement : nextElement;
      const positionLeftElement = elementoToNavigate.getBoundingClientRect().left;
      tabsWrapper.scrollLeft = positionLeftElement;
      elementoToNavigate.focus();
      return onSelectTab === null || onSelectTab === void 0 ? void 0 : onSelectTab(elementoToNavigate.id);
    }
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      const previousElement = elementsToNavigate[index - 1];
      const elementoToNavigate = !previousElement ? lastElement : previousElement;
      const positionLeftElement = elementoToNavigate.getBoundingClientRect().left;
      tabsWrapper.scrollLeft = positionLeftElement;
      elementoToNavigate.focus();
      return onSelectTab === null || onSelectTab === void 0 ? void 0 : onSelectTab(elementoToNavigate.id);
    }
  });
};